<template>
    <form id="mainForm" action="#" method="post">
        <Card>
            <template #title>
                <Toolbar>
                    <template #left>
                        <div class="p-card-title">Performance Report </div>
                    </template>
                </Toolbar>
            </template>
            <template #content>
                <div style="font-style: italic;color:red;">{{ $t('auth_report') }}
                    <Button :label="$t('click_here')" class="p-button p-component p-button-link"
                        @click="showReportAuth()"
                        style="color: red;margin-bottom: -7px;margin-left: -10px;font-weight: bold;font-style: italic;text-decoration: underline;" />
                </div>
                <div v-if="header && this.Error_Message && !this.submitted">
                    <Message severity="warn" :closable="false" v-html="this.Error_Message">
                    </Message>
                </div>
                <div class="p-inputtext-sm p-fluid">
                    <div class="grid">
                        <div class="col-6">
                            <div class="field grid">
                                <label for="Unit_Code" class="col-4">{{ $t('unit') }}</label>
                                <div class="col-8 md-8">
                                    <CustomMultiSelect class="p-inputtext-sm" v-model="UnitCode" type="text"
                                        placeholder="All" :url="this.$API_URL + 'list/unit_code'" :minLength="0"
                                        :params="{}" :filter="true" :optionValue="'id'" :optionLabel="'text'" />
                                </div>
                            </div>
                            <div class="field grid">
                                <label for="Functional_Code" class="col-4">{{ $t('functional') }}</label>
                                <div class="col-8 md-8">
                                    <CustomMultiSelect class="p-inputtext-sm" v-model="FunctionalCode" type="text"
                                        placeholder="All" :url="this.$API_URL + 'list/functional_code'" :minLength="0"
                                        :params="{}" :filter="true" :optionValue="'id'" :optionLabel="'text'" />
                                </div>
                            </div>
                            <div class="field grid">
                                <label for="Department_Code" class="col-4">{{ $t('department') }}</label>
                                <div class="col-8 md-8">
                                    <CustomMultiSelect class="p-inputtext-sm" v-model="DepartmentCode" type="text"
                                        placeholder="All" :url="this.$API_URL + 'list/department_code'" :minLength="0"
                                        :params="{}" :filter="true" :optionValue="'id'" :optionLabel="'text'" />
                                </div>
                            </div>
                            <div class="field grid">
                                <label for="Grade_Code" class="col-4">{{ $t('grade') }}</label>
                                <div class="col-8 md-8">
                                    <CustomMultiSelect class="p-inputtext-sm" v-model="this.GradeCode" type="text"
                                        placeholder="All" :url="this.$API_URL + 'list/grade_code'" :minLength="0"
                                        :params="{}" :filter="true" :optionValue="'id'" />
                                </div>
                            </div>
                            <div class="field grid">
                                <label for="Year_Performance" class="col-4">{{ $t('performance_period') }}</label>
                                <div class="col-8 md-8">
                                    <MultiSelect v-model="this.Year_Performance" :options="nextyears"
                                        optionLabel="value" optionValue="value" :placeholder="$t('year')" display="chip"
                                        @change="this.resetTbl()" />
                                </div>
                            </div>
                        </div>
                        <div class="col-6">
                            <div class="field grid">
                                <label for="Company_Code" class="col-4">{{ $t('company') }}</label>
                                <div class="col-8 md-8">
                                    <CustomMultiSelect class="p-inputtext-sm" v-model="CompanyCode" type="text"
                                        placeholder="All" :url="this.$API_URL + 'list/company_code'" :minLength="0"
                                        :params="{}" :filter="true" :optionValue="'id'" :optionLabel="'text'" />
                                </div>
                            </div>
                            <div class="field grid">
                                <label for="Division_Code" class="col-4">{{ $t('division') }}</label>
                                <div class="col-8 md-8">
                                    <CustomMultiSelect class="p-inputtext-sm" v-model="DivisionCode" type="text"
                                        placeholder="All" :url="this.$API_URL + 'list/division_code'" :minLength="0"
                                        :params="{}" :filter="true" :optionValue="'id'" :optionLabel="'text'" />
                                </div>
                            </div>
                            <div class="field grid">
                                <label for="Region" class="col-4">{{ $t('business_unit') }}</label>
                                <div class="col-8 md-8">
                                    <CustomMultiSelect class="p-inputtext-sm" v-model="Region" type="text"
                                        placeholder="All" :url="this.$API_URL + 'list/lookup'" :minLength="0"
                                        :params="{ group: 'REGION' }" :filter="true" :optionValue="'id'"
                                        :optionLabel="'text'" />
                                </div>
                            </div>
                            <div class="field grid">
                                <label for="Directorate_Code" class="col-4">{{ $t('directorate') }}</label>
                                <div class="col-8 md-8">
                                    <CustomMultiSelect class="p-inputtext-sm" v-model="DirectorateCode" type="text"
                                        placeholder="All" :url="this.$API_URL + 'list/directorate_code'" :minLength="0"
                                        :params="{}" :filter="true" :optionValue="'id'" :optionLabel="'text'" />
                                </div>
                            </div>
                            <!-- <div class="field grid">
                                <label for="Period_Year" class="col-4">{{ $t('appraisal_period') }}</label>
                                <div class="col-8 md-8">
                                    <Dropdown v-model="header.Period_Year" :options="years" optionLabel="value"
                                        optionValue="value" :placeholder="$t('year')" />
                                </div>
                            </div> -->
                            <div class="field grid">
                                <label for="Name" class="col-4">{{ $t('name') }}</label>
                                <div class="col-8 md-8">
                                    <InputText name="Name" v-model="header.Name" required="true" type="text"
                                        :placeholder="$t('name')" />
                                </div>
                            </div>
                            <div class="field grid">
                                <label for="Job_Status_Code" class="col-4">{{ $t('jobStatus') }}</label>
                                <div class="col-8 md-8">
                                    <CustomMultiSelect class="p-inputtext-sm" v-model="this.JobStatusCode" type="text"
                                        placeholder="All" :url="this.$API_URL + 'list/job_status_code'" :minLength="0"
                                        :params="{}" :filter="true" :optionValue="'id'" />
                                    <small v-if="!this.JobStatusCode || this.JobStatusCode == ''" class="p-error">
                                        {{ $t('default_jobstatus') }}
                                    </small>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Button type="button" label="Generate" @click="generate()" icon="pi pi-external-link" />
                <br />
                <div class="p-inputtext-sm p-fluid" v-if="this.reportTbl">
                    <center>
                        <h4>Performance Appraisal</h4>
                    </center>
                    <div class="grid">
                        <div class="col-6">
                            <Chart type="bar" :data="this.chartData()" :options="barOptions" :height="190"
                                v-if="this.reportTbl" />
                        </div>
                        <div class="col-6">
                            <table style="width:100%;">
                                <thead>
                                    <tr>
                                        <td rowspan="2" style="font-weight: bold;">Grade</td>
                                        <td :colspan="this.Year_Performance.length" style="font-weight: bold;">Year</td>
                                    </tr>
                                    <tr>
                                        <td v-for="dt in [...new Set(this.Year_Performance)]" v-bind:key="dt"
                                            style="font-weight: bold;">{{ dt }}</td>
                                    </tr>
                                    <tr>
                                        <td>A</td>
                                        <td v-for="dt in [...new Set(this.Year_Performance)]" v-bind:key="dt">
                                            {{ this.reportTbl.filter(a => a.Standard == dt && a.Grade == 'A')[0] !=
                    undefined ?
                    this.reportTbl.filter(a => a.Standard == dt && a.Grade == 'A')[0].Amount : 0
                                            }}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>B</td>
                                        <td v-for="dt in [...new Set(this.Year_Performance)]" v-bind:key="dt">
                                            {{ this.reportTbl.filter(a => a.Standard == dt && a.Grade == 'B')[0] !=
                    undefined ?
                    this.reportTbl.filter(a => a.Standard == dt && a.Grade == 'B')[0].Amount : 0
                                            }}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>C</td>
                                        <td v-for="dt in [...new Set(this.Year_Performance)]" v-bind:key="dt">
                                            {{ this.reportTbl.filter(a => a.Standard == dt && a.Grade == 'C')[0] !=
                    undefined ?
                    this.reportTbl.filter(a => a.Standard == dt && a.Grade == 'C')[0].Amount : 0
                                            }}
                                        </td>
                                    </tr>
                                </thead>
                            </table>
                        </div>
                    </div>
                </div>
            </template>
        </Card>
    </form>

    <ReportAuth v-if="reportAuth" :isVisible="reportAuth" :initialErrorMessage="errormessage"
        @hide="hideReportAuthDialog" />
</template>

<script>
export default {
    data() {
        return {
            mode: "",
            dataUrl: "Report/performance_report",
            reportTbl: null,
            excelTbl: null,
            showReport: false,
            loadingReport: false,
            Error_Message: "",
            mergedOptions: [
                { label: "Y", value: 1 },
                { label: "N", value: 0 },
            ],
            UnitCode: null,
            FunctionalCode: null,
            DepartmentCode: null,
            GradeCode: null,
            SectionCode: null,
            CompanyCode: null,
            DivisionCode: null,
            JobStatusCode: null,
            Region: null,
            DirectorateCode: null,
            Year_Performance: null,
            header: {
                Unit_Code: null,
                Functional_Code: null,
                Department_Code: null,
                Grade_Code: null,
                Section_Code: null,
                Company_Code: null,
                Division_Code: null,
                Job_Status_Code: null,
                Period_Year: new Date().getFullYear(),
                Region: null,
                Directorate_Code: null,
                Name: "",
                Is_Export: false,
                Grade_Type: "All",
                Year_Performance: null
            },
            submitted: false,
            dataBar: [],
            dataSets: [],
            colorBar: null,
            reportAuth: false
        };
    },
    methods: {
        reopenTab() {
            this.showReport = true;
        },
        resetBtn() {
            this.showReport = false;
        },
        tableToExcel() {
            this.loadingReport = !this.loadingReport; data
        },
        generate() {
            this.Error_Message = "";

            if (!this.Unit_Code && !this.Functional_Code && !this.Department_Code && !this.Grade_Code && !this.Year_Performance
                && !this.Section_Code && !this.Company_Code && !this.Division_Code && !this.Region && this.Name == '' && !this.JobStatusCode) {
                this.Error_Message = "Pilih minimal 1 filter!";
            }
            else if (!this.Year_Performance) {
                this.Error_Message = "Tahun Performance diperlukan";
            }
            else
                this.getReport();
        },
        getReport() {
            var self = this;
            this.$emit('block-ui');

            this.header.Unit_Code = this.UnitCode ? this.UnitCode.join(',') : '';
            this.header.Functional_Code = this.FunctionalCode ? this.FunctionalCode.join(',') : '';
            this.header.Department_Code = this.DepartmentCode ? this.DepartmentCode.join(',') : '';
            this.header.Grade_Code = this.GradeCode ? this.GradeCode.join(',') : '';
            this.header.Section_Code = this.SectionCode ? this.SectionCode.join(',') : '';
            this.header.Company_Code = this.CompanyCode ? this.CompanyCode.join(',') : '';
            this.header.Division_Code = this.DivisionCode ? this.DivisionCode.join(',') : '';
            this.header.Region = this.Region ? this.Region.join(',') : '';
            this.header.Directorate_Code = this.DirectorateCode ? this.DirectorateCode.join(',') : '';
            this.header.Year_Performance = this.Year_Performance ? this.Year_Performance.join(',') : '';
            this.header.Job_Status_Code = this.JobStatusCode ? this.JobStatusCode.join(',') : '';

            this.$axios.post(this.$API_URL + this.dataUrl, this.header)
                .then((response) => {
                    if (response.data.success) {
                        self.reportTbl = response.data.data;
                    }

                    this.$emit('unblock-ui');
                })
                .catch(() => {
                    this.$emit('unblock-ui');
                })
                .finally(() => {
                    self.dataSets = [];

                    self.Year_Performance.forEach(e => {
                        let dataYear = self.reportTbl.filter(a => a.Standard == e).map(a => a.Amount);
                        this.colorBar = '#' + Math.floor(Math.random() * 16777215).toString(16);

                        this.dataSets.push(
                            {
                                label: e,
                                data: dataYear,
                                backgroundColor: [this.colorBar],
                                borderColor: [this.colorBar],
                                borderWidth: 1,
                                sliced: true
                            }
                        )
                    })

                    this.applyLightTheme();
                });
        },
        chartData() {
            return {
                labels: ['A', 'B', 'C'],
                datasets: this.dataSets
            }
        },
        showError() {
            this.loadingReport = !this.loadingReport;
        },
        closeReport() {
            this.showReport = false;
        },
        applyLightTheme() {
            this.barOptions = {
                plugins: {
                    legend: {
                        labels: {
                            color: '#495057',
                            usePointStyle: true
                        }
                    }
                },
                scales: {
                    y: {
                        beginAtZero: true,
                        title: 'deferfe'
                    },
                }
            };
        },
        resetTbl() {
            this.reportTbl = null;
        },
        showReportAuth() {
            this.reportAuth = true;
        },
        hideReportAuthDialog() {
            this.reportAuth = false;
        }
    },
    mounted() { },
    computed: {
        nextyears() {
            let years = [];
            for (var i = 2023; i <= new Date().getFullYear(); i++) {
                years.push({ value: i.toString() })
            }
            return years;
        },
    }
};
</script>

<style scoped>
table,
th,
td {
    border: 1px solid black !important;
    border-collapse: collapse !important;
    text-align: center;
    font-family: Arial, Helvetica, sans-serif;
    padding: 5px;
    font-size: 9pt;
}
</style>